import createDataContext from "./createDataContext";

var axios = require("axios");
var qs = require("qs");

const reducer = (state, action) => {
  switch (action.type) {
    case "get_wallet":
      if (action.payload === "error") {
        return {
          ...state,
          wallet: {},
          getWalletError: action.payload === "error" ? true : false,
        };
      } else {
        return {
          ...state,
          ...action.payload,
          getWalletError: false,
          modalOpen: false,
        };
      }
    case "add_payment_error":
      return {
        ...state,
        addingPayment: false,
        addPaymentError: action.payload,
      };
    case "adding_payment":
      // console.log("in adding payment", action.payload);
      return {
        ...state,
        addingPayment: action.payload,
      };
    case "add_payment_success":

      console.log('add payment success bradley', action);
      // !action.payload,
      return {
        ...state,
        addingPayment: false,
        addPaymentSuccess: action.payload,
      };
    case "toggle_modal":
      return {
        ...state,
        modalOpen: !state.modalOpen,
      };
    case "deleting_payment_type":
      return {
        ...state,
        deletingPaymentMethod: action.payload,
      };
    default:
      return state;
  }
};

const getWallet = (dispatch) => async () => {
  console.log("GETTTTING WALLET");
  try {
    axios({
      method: "post",
      data: qs.stringify({
        method: "getWallet",
      }),
      withCredentials: true,
    }).then((response) => {
      console.log("GET WALLETS", response.data);

      dispatch({
        type: "get_wallet",
        payload: response.data,
      });
    });
  } catch {
    console.log("ERrrrrror getting wallet");
  }
};

const addPaymentMethod = (dispatch) => async (
  {
    paymentMethod,
    bankAcctType,
    accountNumber,
    routingABA,
    expMonth,
    expYear,
    nameOnAccount,
    isDefault,
    autoPay,
    op,
  },
  history
) => {
  dispatch({
    type: "adding_payment",
    payload: true,
  });

  try {
    const response = await axios({
      method: "post",
      data: qs.stringify({
        method: "addPaymentMethod",
        paymentMethod,
        bankAcctType,
        accountNumber,
        routingABA,
        expMonth,
        expYear,
        nameOnAccount,
        default: isDefault,
        autoPay,
      }),
      withCredentials: true,
    });
    console.log("ADD PAYMENT RESPONSE", response.data);

    if (response.data.status === 1) {
      console.log("get wallet");
      try {
        const getWalletResponse = await axios({
          method: "post",
          data: qs.stringify({
            method: "getWallet",
          }),
          withCredentials: true,
        });
        console.log("GET WALLET RESPONSE", getWalletResponse.data);
        if (getWalletResponse.data.status === 1) {
          dispatch({ type: "add_payment_success", payload: true });

          dispatch({
            type: "get_wallet",
            payload: getWalletResponse.data,
          });

          setTimeout(() => {
            dispatch({ type: "add_payment_success", payload: false });
          }, 2000);
        } else {
          dispatch({
            type: "get_wallet",
            payload: "error",
          });
        }
      } catch {
        console.log("ERrrrrror getting wallet");
      }
    } else {
      dispatch({
        type: "add_payment_error",
        paylaod: true,
      });
    }
  } catch {
    console.log("Error adding payment method");
    dispatch({
      type: "add_payment_error",
      payload: true,
    });
  }
};

const toggleModal = (dispatch) => async () => {
  dispatch({ type: "toggle_modal" });
};

const deletePaymentMethod = (dispatch) => async ({ paymentMethod }) => {
  dispatch({ type: "deleting_payment_type", payload: true });
  console.log("Inside DELTE PAYMENT METH");
  console.log(paymentMethod);

  try {
    const deletePaymentResponse = await axios({
      method: "post",
      data: qs.stringify({
        method: "deletePaymentMethod",
        paymentMethod,
      }),
      withCredentials: true,
    });

    if (deletePaymentResponse.data.status === 1) {
      dispatch({ type: "deleting_payment_type", payload: false });

      axios({
        method: "post",
        data: qs.stringify({
          method: "getWallet",
        }),
        withCredentials: true,
      }).then((response) => {
        console.log("GET WALLET", response.data);

        dispatch({
          type: "get_wallet",
          payload: response.data,
        });
      });
    }

    console.log("DELETE PAYMENT RESPONSE", deletePaymentResponse);
  } catch {
    console.log("Error deleting payment method");
  }
};

const updateAutoPay = (dispatch) => async (
  { paymentMethod, 
    state, 
    autopay_reminder_days = '', 
    autopay_pay_advance_days = '', 
    autopay_pay_day_of_month = '', 
    autopay_max_amount = '', 
    autopay_amount_override = '',
    autopay_start_date
  }) => {
  console.log(paymentMethod);

  try {
    const updateAutoPayResponse = await axios({
      method: "post",
      data: qs.stringify({
        method: "updateAutoPay",
        paymentMethod,
        state,
        autopay_reminder_days,
        autopay_pay_advance_days,
        autopay_pay_day_of_month,
        autopay_max_amount,
        autopay_amount_override,
        autopay_start_date
      }),
      withCredentials: true,
    });

    if (updateAutoPayResponse.data.status === 1) {
      axios({
        method: "post",
        data: qs.stringify({
          method: "getWallet",
        }),
        withCredentials: true,
      }).then((response) => {
        console.log("GET WALLET", response.data);

        dispatch({
          type: "get_wallet",
          payload: response.data,
        });
      });
    }

    console.log("UPDATE AUTO PAY RESPONSE", updateAutoPayResponse);
  } catch {
    console.log("Error deleting payment method");
  }
};

const updateDefaultPaymentMethod = (dispatch) => async ({
  paymentMethod,
  state,
}) => {
  console.log(paymentMethod);

  try {
    const updateDefaultResponse = await axios({
      method: "post",
      data: qs.stringify({
        method: "updateDefaultPaymentMethod",
        paymentMethod,
        state,
      }),
      withCredentials: true,
    });

    if (updateDefaultResponse.data.status === 1) {
      axios({
        method: "post",
        data: qs.stringify({
          method: "getWallet",
        }),
        withCredentials: true,
      }).then((response) => {
        console.log("GET WALLETs", response.data);

        dispatch({
          type: "get_wallet",
          payload: response.data,
        });
      });
    }

    console.log("UPDATE DEFAULT PAYMENT RESPONSE", updateDefaultResponse);
  } catch {
    console.log("Error deleting payment method");
  }
};


export const { Provider, Context } = createDataContext(
  reducer,
  {
    getWallet,
    addPaymentMethod,
    toggleModal,
    deletePaymentMethod,
    updateAutoPay,
    updateDefaultPaymentMethod,
  },
  {
    wallet: {},
    addPaymentError: false,
    addingPayment: false,
    modalOpen: false,
    autoPay: {
      autoPaySettings : {
        autopay_reminder_days : "15",
        autopay_pay_advance_days : "",
        autopay_pay_day_of_month :"",
        autopay_max_amount : "",
        autopay_amount_override :"",
        autopay_start_date : "", 
      },
    },
    addPaymentSuccess: false,
    deletingPaymentMethod: false,
  }
);
